import { useQuery } from "react-query";
import { getSlideById } from "../services/SlideApi";

const useSlide = (slideId = null) => {
    return useQuery(['slide', slideId], () => getSlideById(slideId))
}
 
export default useSlide;